module.exports = __webpack_public_path__ + "img/close_square.52599311.svg";